/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![MobilePhoneSettingsIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABG0lEQVR4nO2VsW7CQAyGmai68iB9gIoHyIDPXiy7r1KFLUN4DuAN+gzAS4AEEt26srWpjuTECQiXnIhYsOTl4rvP/u9i93qPMGbuG5IJoHwb0uKWA8nekOZ2T2OA3RA62Fx63hhQZVUgynsodkQfQ1dJmwqOWXUV/wSE7XkHd5cIUA+A+tMZgJkHSZK8dAZobTEAIN1ZvysAUDODugSUsdf00nJNsyDANrKbiaAsarsr6jIIuOj9qAd7oV5cWq7Lr0GZHp30z1XSGmBIC2Z+rWI2p2xl6sk289bX8QCUdTTADZyrMoG+nUtkZbEHA+ncSQQon7EjM/USWdVfsixqAeXQ1/xaJYDy5cmRVS/JVdLsmcaY/ckM6fb8wz/PWWK/o7lPKwAAAABJRU5ErkJggg==)
 */
export const MobilePhoneSettingsIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        d="M8 1a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h4.3c.4 0 .65-.46.46-.82a6.97 6.97 0 0 1-.63-4.53c.06-.33-.18-.65-.51-.65H8a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v7.62c0 .33.32.57.65.51a7 7 0 0 1 .85-.11c.28-.02.5-.24.5-.52V4a3 3 0 0 0-3-3H8Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path
        fillRule="evenodd"
        d="M18.06 14.57c-.02-.25.12-.5.37-.54a5.04 5.04 0 0 1 1.14 0c.25.03.4.29.37.54-.04.48.13.9.47 1.04.33.14.75-.04 1.06-.4.16-.2.44-.28.64-.13.3.24.57.51.8.81.16.2.08.48-.11.64-.37.31-.55.73-.4 1.06.13.34.55.51 1.03.47.25-.02.5.12.54.37a5.04 5.04 0 0 1 0 1.14c-.03.25-.29.39-.54.37-.48-.04-.9.13-1.04.47-.14.33.04.75.4 1.06.2.16.28.44.13.64-.24.3-.51.57-.81.8-.2.16-.48.08-.64-.11-.31-.37-.73-.55-1.06-.4-.34.13-.51.55-.47 1.03.02.25-.12.5-.37.54a5.05 5.05 0 0 1-1.14 0c-.25-.03-.39-.29-.37-.54.04-.48-.13-.9-.47-1.04-.33-.14-.75.04-1.06.4-.16.2-.44.28-.64.13-.3-.24-.57-.51-.8-.81-.16-.2-.08-.48.11-.64.37-.31.55-.73.4-1.06-.13-.34-.55-.51-1.03-.47-.25.02-.5-.12-.54-.37a5.04 5.04 0 0 1 0-1.14c.03-.25.29-.39.54-.37.48.04.9-.13 1.04-.47.14-.33-.04-.75-.4-1.06-.2-.16-.28-.44-.13-.64.24-.3.51-.57.81-.8.2-.16.48-.08.64.11.31.37.73.55 1.06.4.34-.13.51-.55.47-1.03ZM19 20.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
        clipRule="evenodd"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
